// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nc-0";
export var buttonContainer = "_nc-3";
export var cancelButton = "_nc-4";
export var headerSection = "_nc-6";
export var headerTitle = "_nc-9";
export var messageSideLeft = "_nc-1";
export var messageSideRight = "_nc-2";
export var orderNumberContainer = "_nc-7";
export var orderNumberLabel = "_nc-8";
export var submitButton = "_nc-5";